export default __webpack_public_path__ + "static/media/cloud.a7078711.svg";